import type { FunctionComponent } from 'react';

import {
  Icon,
  registerIcon,
  StyledAvatar,
  useI18n,
  VisuallyHiddenText
} from '@pega/cosmos-react-core';
import type { ForwardProps, OmitStrict } from '@pega/cosmos-react-core';
import * as chatIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/chat.icon';
import { NavigationListItem } from '@pega/cosmos-react-core/lib/components/AppShell/NavigationList';

import type { ChatSettingsPanelProps } from './Chat.types';
import {
  StyledChatControlPanelIcon,
  StyledUserStatusIcon,
  userAvailabilityTheme
} from './ChatSettingsPanel.styles';

registerIcon(chatIcon);

export const ChatControlPanelIcon: FunctionComponent<
  OmitStrict<ChatSettingsPanelProps, 'onClick'> & ForwardProps
> = ({ status, label, ...restProps }) => {
  return (
    <StyledChatControlPanelIcon
      {...(status ? { as: StyledAvatar, shape: 'circle', size: 'm' } : {})}
      {...restProps}
      userStatus={status}
    >
      <Icon name='chat' />
      {status && userAvailabilityTheme[status].icon && (
        <StyledUserStatusIcon userStatus={status}>
          <Icon name={userAvailabilityTheme[status].icon!} />
        </StyledUserStatusIcon>
      )}
      <VisuallyHiddenText>{label}</VisuallyHiddenText>
    </StyledChatControlPanelIcon>
  );
};

const ChatSettingsPanel: FunctionComponent<ChatSettingsPanelProps & ForwardProps> = ({
  status,
  label,
  onClick,
  ...restProps
}) => {
  const t = useI18n();
  return (
    <NavigationListItem
      primary={status ? `${label} (${t(status)})` : label}
      visual={<ChatControlPanelIcon status={status} label={label} {...restProps} />}
      onClick={onClick}
    />
  );
};

export default ChatSettingsPanel;
